import { render, staticRenderFns } from "./Turn.vue?vue&type=template&id=66a925cc&lang=pug&"
import script from "./Turn.vue?vue&type=script&lang=js&"
export * from "./Turn.vue?vue&type=script&lang=js&"
import style0 from "./Turn.vue?vue&type=style&index=0&id=66a925cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports